import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';

export const DynamicPurchaseCheckbox = () => {
  const intl = useIntl();

  return (
    <StyledQmarkCheckboxes>
      <Checkbox
        itemClassName={'filter-single-checkbox'}
        name="is_dynamic"
        label={intl.formatMessage({ id: 'products.dynamic_purchase' })}
        value={'test'}
      />
    </StyledQmarkCheckboxes>
  );
};
